/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FixedPriceProjectDetailsResourceAllOfQuoteLines
 */
export interface FixedPriceProjectDetailsResourceAllOfQuoteLines {
    /**
     * 
     * @type {string}
     * @memberof FixedPriceProjectDetailsResourceAllOfQuoteLines
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceProjectDetailsResourceAllOfQuoteLines
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceProjectDetailsResourceAllOfQuoteLines
     */
    unitPriceExcludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceProjectDetailsResourceAllOfQuoteLines
     */
    totalExcludingTaxes: number;
}

/**
 * Check if a given object implements the FixedPriceProjectDetailsResourceAllOfQuoteLines interface.
 */
export function instanceOfFixedPriceProjectDetailsResourceAllOfQuoteLines(value: object): value is FixedPriceProjectDetailsResourceAllOfQuoteLines {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('unitPriceExcludingTaxes' in value) || value['unitPriceExcludingTaxes'] === undefined) return false;
    if (!('totalExcludingTaxes' in value) || value['totalExcludingTaxes'] === undefined) return false;
    return true;
}

export function FixedPriceProjectDetailsResourceAllOfQuoteLinesFromJSON(json: any): FixedPriceProjectDetailsResourceAllOfQuoteLines {
    return FixedPriceProjectDetailsResourceAllOfQuoteLinesFromJSONTyped(json, false);
}

export function FixedPriceProjectDetailsResourceAllOfQuoteLinesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceProjectDetailsResourceAllOfQuoteLines {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'quantity': json['quantity'],
        'unitPriceExcludingTaxes': json['unitPriceExcludingTaxes'],
        'totalExcludingTaxes': json['totalExcludingTaxes'],
    };
}

export function FixedPriceProjectDetailsResourceAllOfQuoteLinesToJSON(value?: FixedPriceProjectDetailsResourceAllOfQuoteLines | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'quantity': value['quantity'],
        'unitPriceExcludingTaxes': value['unitPriceExcludingTaxes'],
        'totalExcludingTaxes': value['totalExcludingTaxes'],
    };
}

